<template>
    <EditProfesseur />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import EditProfesseur from "@/components/Professeur/EditProfesseur.vue";
  
    export default defineComponent({
      name: "EditProfesseurPage",
      components: {
        
        EditProfesseur,
      },
    });
  </script>